// Animator.jsx
import React from 'react';
import PropTypes from 'prop-types';

class Animator extends React.PureComponent {
  state = {
    now: new Date(),
  };

  componentDidMount() {
    this.startLoop();
  }

  componentDidUpdate(prevProps) {
    if (this.props.fps !== prevProps.fps) {
      this.fpsInterval = 1000 / this.props.fps;
      if (this._timerId) {
        this.stopLoop();
        this.startLoop();
      }
    }
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  loop = () => {
    this.scheduleNextTick();
    this.setState({ now: new Date() });
  };

  // schedule on the absolute time grid (e.g. whole seconds for fps 1) so
  // setTimeout lateness doesn't accumulate and countdowns don't skip seconds
  scheduleNextTick = () => {
    this._timerId = window.setTimeout(
      this.loop,
      this.fpsInterval - (Date.now() % this.fpsInterval)
    );
  };

  startLoop = () => {
    // fps <= 0 makes fpsInterval Infinity, which setTimeout coerces to 0
    // and turns the loop into a busy loop
    if (this._timerId || !(this.props.fps > 0)) {
      return;
    }
    this.fpsInterval = 1000 / this.props.fps;
    this.scheduleNextTick();
  };

  stopLoop = () => {
    window.clearTimeout(this._timerId);
    this._timerId = undefined;
  };

  render() {
    const { children, render, ...props } = this.props;
    const { now } = this.state;

    if (render) {
      return render(now, this.stopLoop);
    } else {
      const child = React.Children.only(children);
      return React.cloneElement(child, {
        ...props,
        now,
        stopAnimator: this.stopLoop,
        startAnimator: this.startLoop,
      });
    }
  }
}

Animator.propTypes = {
  fps: PropTypes.number,
  children: PropTypes.node,
  render: PropTypes.func,
};

Animator.defaultProps = {
  fps: 5,
  children: null,
  render: null,
};

export default Animator;
